import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import {
  Button,
  Select,
  Grid
} from "@material-ui/core";
import NativeSelect from '@material-ui/core/NativeSelect';

import EditIcon from "@material-ui/icons/Edit";

import screeningStyles from "./screeningDetails.module.css";
import commonStyles from '../common/common.module.css';
import { getScreeningCode } from '../../utils/screening';
import moment from 'moment';
import ScreeningConsignment from '../../models/ScreeningConsignment';
import SecurityLogs from '../../models/SecurityLogs';
import Screening from '../../models/Screening';

interface ConsignmentErrors {
  contents: string;
  security_status: string;
};

interface ConsignmentDisabled {
  contents: boolean;
  transit: boolean;
  additional_info: boolean;
};

interface SecurityConsignmentProps {
  classes: any;
  enableFields: (field: string) => void;
  onChange: (event: any) => void;
  save: () => void;
  consignment: ScreeningConsignment;
  consignmentDisabled: ConsignmentDisabled;
  consignmentErrors: ConsignmentErrors;
  userLogs: Array<SecurityLogs>;
  print: () => void;
  emailConsignment: () => void;
  disableSave: boolean;
  disableEmail: boolean;
  buttonState: boolean;
};

const styles = (theme: Theme) =>

  createStyles({
    red: {
      backgroundColor: 'red !important',
    },
    activeTab: {
      '&.MuiTab-textColorInherit.Mui-selected': {
        backgroundColor: 'var(--secondarygreen)',
      }
    },
    tabWrapper: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    },
  });

const securityConsignment = (props: SecurityConsignmentProps) => {

  const { classes } = props;
  const receivedFrom = props.consignment.received_from;

  // Box 9 rules
  const shouldPopulateBox9 =
    receivedFrom && (
      receivedFrom.identifier === 'Received screened from CCSF' ||
      receivedFrom.identifier === 'CCSF' ||
      receivedFrom.identifier === 'Received Screened from Interline' ||
      receivedFrom.identifier === 'Screened at origin and arrived with proper chain of custody'
    ) || (props.consignment.screening[0] && props.consignment.screening[0].screening_details === 'Screened at origin and arrived with proper chain of custody') ;// Only for "screened at origin with proper chain of custody"


  return (
    <Fragment>
      <div className={commonStyles.p3}>
        <Grid container className={`${screeningStyles.csdGridWrapper} ${commonStyles.cardbkg}`} spacing={3}>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={6}>
            <label className={commonStyles.label}>Regulated Entity Category (RA KC or AO) and Identifier (Of the regulated party issuing the security status)</label>
            <div className={screeningStyles.identityClass}>
              <span>
                {props.consignment.received_from.name}
              </span>
              <br />
              <span>
                {props.consignment.received_from.code}
              </span>
            </div>
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper}`} xs={12} sm={6}>
            <div className={commonStyles.mtauto}>
              <label className={commonStyles.label}>Unique Consignment Identifier</label>
              <TextField
                label=""
                fullWidth={true}
                disabled={true}
                InputProps={{
                  classes: {
                    input: screeningStyles.fs34,
                    root: screeningStyles.disabledClass
                  }
                }}
                variant="outlined"
                value={props.consignment.awb}
              />
            </div>

          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.dFlex} ${commonStyles.gap20}`} xs={12} sm={6}>
            <div className={`${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`}>
              <label className={commonStyles.label}>Contents of consignment</label>
              <TextField
                label=""
                id='contents'
                fullWidth={true}
                variant="outlined"
                value={props.consignment.contents}
                disabled={props.consignmentDisabled.contents}
                className={classes.disabledClass}
                onChange={(e) => props.onChange(e)}
                error={props.consignmentErrors.contents !== ''}
                helperText={props.consignmentErrors.contents !== '' ? props.consignmentErrors.contents + ' Contents' : ''}
              />
            </div>
            <EditIcon className={commonStyles.mt3} onClick={() => props.enableFields('contents')} />
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={6} >
            <div className={`${commonStyles.fSpaceBtw} ${commonStyles.gap10}`}>
              <div>
                <label className={commonStyles.label}>Pieces</label>
                <TextField
                  label=""
                  disabled={true}
                  InputProps={{
                    classes: { root: screeningStyles.disabledClass }
                  }}
                  fullWidth={true}
                  variant="outlined"
                  value={props.consignment.pieces}
                />
              </div>
              <div>
                <label className={commonStyles.label}>Weight</label>
                <TextField
                  label=""
                  disabled={true}
                  fullWidth={true}
                  InputProps={{
                    classes: { root: screeningStyles.disabledClass }
                  }}
                  variant="outlined"
                  value={props.consignment.weight}
                />
              </div>
            </div>

          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={3}>
            <label className={commonStyles.label}>Origin</label>
            <TextField
              label=""
              fullWidth={true}
              InputProps={{
                classes: { root: screeningStyles.disabledClass }
              }}
              disabled={true}
              variant="outlined"
              value={props.consignment.org}
            />
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={3}>
            <label className={commonStyles.label}>Destination</label>
            <TextField
              label=""
              disabled={true}
              InputProps={{
                classes: { root: screeningStyles.disabledClass }
              }}
              fullWidth={true}
              variant="outlined"
              value={props.consignment.dst}
            />
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.dFlex} ${commonStyles.gap20}`} xs={12} sm={6}>
            <div className={`${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`}>
              <label className={commonStyles.label}>Transfer / Transit Points (If Known)</label>
              <TextField
                label=""
                id='transit'
                fullWidth={true}
                variant="outlined"
                onChange={(e) => props.onChange(e)}
                disabled={props.consignmentDisabled.transit}
                value={props.consignment.transit}
              />
            </div>
            <EditIcon className={commonStyles.mt3} onClick={() => props.enableFields('transit')} />
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={2}>
            <label className={commonStyles.label}>Security Status (Please select)</label>
            <NativeSelect
              name='security_status'
              fullWidth={true}
              value={props.consignment.security_status}
              variant="outlined"
              onChange={(e) => props.onChange(e)}
              error={props.consignmentErrors.security_status !== ''}
            >
              <option value={''} className={classes.optionClass}></option>
              <option value={'SPX'} className={classes.optionClass}>SPX</option>
              <option value={'SHR'} className={classes.optionClass}>SHR</option>
            </NativeSelect>
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={10}>
            <p className={`${commonStyles.textCenter} ${commonStyles.mt0}`}>Reason for issuing security status</p>
            <Grid container spacing={3}>
              <Grid
                item
                className={`${screeningStyles.csdGridItem} ${screeningStyles.csdinnerItem}`}
                xs={4}
              >
                <label className={`${commonStyles.label} ${commonStyles.mb2}`}>
                  Received From
                </label>

                <div className={screeningStyles.fs12}>
                  {props.consignment.received_from_list && props.consignment.received_from_list.length > 0 ? (
                    props.consignment.received_from_list.map((item, index) => (
                      <Fragment key={index}>
                        <small>{item.name}</small>
                        <small>{item.code}</small>
                      </Fragment>
                    ))
                  ) : (
                    <>
                      <small>&nbsp;</small>
                      <small>&nbsp;</small>
                      <small>&nbsp;</small>
                    </>
                  )}
                </div>
              </Grid>

              <Grid item className={`${screeningStyles.csdGridItem} ${screeningStyles.csdinnerItem}`} xs={4}>
                <label className={`${commonStyles.label} ${commonStyles.mb2}`}>Screening Method</label>
                <div className={screeningStyles.fs12}>
                  {props.consignment.screening.map((scr: any, index: number) => {
                    return (
                      <Fragment key={index}>
                        {(scr.measure_applied == 'Screened' || scr.measure_applied == 'Alarm Resolution') && getScreeningCode(scr.screening_details.toUpperCase()) ?
                          <small style={{ display: 'block' }}>{`${getScreeningCode(scr.screening_details.toUpperCase())} - ${scr.pieces} Pieces`}</small> : ''}

                        {scr.alarm && scr.alarm_resolution && getScreeningCode(scr.alarm_resolution.toUpperCase()) ?
                          <small style={{ display: 'block' }}>{`${getScreeningCode(scr.alarm_resolution.toUpperCase())} - ${scr.pieces} Pieces`}</small> : ''}
                      </Fragment>
                    )
                  })}
                </div>
              </Grid>
              <Grid item className={`${screeningStyles.csdGridItem} ${screeningStyles.csdinnerItem}`} xs={4}>
                <label className={`${commonStyles.label} ${commonStyles.mb2}`}>Grounds For Exemption (Codes)</label>
                <div className={screeningStyles.fs12}>
                  {props.consignment.screening.map((scr: Screening, index: number) => {
                    return (
                      <small key={index}>{scr.measure_applied.toLowerCase().includes('exemption') ? `${scr.screening_details} - ${scr.pieces} Pieces` : ''}</small>
                    )
                  })}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={12}>
            <label className={commonStyles.label}>Other Screening Methods (If Applicable)</label>
            {props.consignment.screening.map((scr: any, index: number) => {
              if (scr.measure_applied === 'Alternative Screening') {
                return (
                  <p key={index} className={`${screeningStyles.fs12} ${commonStyles.mt0}`}>
                    <strong>Alternative Screening – {scr.screening_details} – {scr.pieces} Pieces</strong>
                  </p>
                );
              }
              return null;
            })}
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={6}>
            <label className={commonStyles.label}>Security Status Issued By</label>
            <p className={screeningStyles.fs12}>Name of Employee:  {props.consignment.screening[props.consignment.screening.length - 1].screened_by}</p>
          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12} sm={6}>
            <label className={commonStyles.label}>Security Status Issued On:</label>
            <p className={screeningStyles.fs12}>Date and Time:  {`${moment(props.consignment.screening[props.consignment.screening.length - 1].date_time).format('DD MMM YY')} ${moment(props.consignment.screening[props.consignment.screening.length - 1].time, 'hh:mm:ss').format("HH:mm")} `}</p>

          </Grid>
          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`} xs={12}>
            <label className={commonStyles.label}>

              Regulated Entity Category (RA, KC, AO) and IDentifier

              (of any regulated party who has accepted the security status given to a consignment by another regulated party)
              <br />
              {' ' + 'RA -' + props.consignment.ghaInfo.name + ' ' + props.consignment.ghaInfo.address}
            </label>
          </Grid>

          <Grid item className={`${screeningStyles.csdGridItem} ${commonStyles.fvMiddle} ${commonStyles.gap20}`} xs={12}>
            <div className={`${commonStyles.inputLabelWrapper} ${commonStyles.mt0}`}>
              <label className={commonStyles.label}>Additional Security Information</label>

              <TextField
                label=""
                fullWidth={true}
                id='additional_info'
                disabled={props.consignmentDisabled.additional_info}
                multiline={true}
                variant="outlined"
                rows={3}
                onChange={(e) => props.onChange(e)}
                value={props.consignment.additional_info}
                minRows={3}
              />
            </div>
            <EditIcon onClick={() => props.enableFields('additional_info')} />
          </Grid>
        </Grid>
      </div>

      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.mt4}`}>
        <div className={commonStyles.maxWidth200}>
          <Button color="primary" variant="contained" className={commonStyles.minWidth100} onClick={props.save} disabled={props.disableSave || props.buttonState}>
            Save
          </Button>
          <div className={`${screeningStyles.fs11} ${screeningStyles.logP}`}>
            <p>Log:</p>
            {props.userLogs.map(log => {
              if (log.type === 'save') {
                return (
                  <p>- {`${log.user} ${moment(log.added_date).format('DD MMM YY')} ${moment(log.added_time, 'hh:mm:ss').format("HH:mm")} `}</p>
                )
              }

            })}

          </div>
        </div>
        <div className={commonStyles.maxWidth200}>
          <Button color="primary" variant="contained" disabled={props.disableEmail || !props.consignment.email || props.buttonState || !props.consignment.id} className={commonStyles.minWidth100} onClick={props.emailConsignment}>
            Send Email
          </Button>
          <div className={`${screeningStyles.fs11} ${screeningStyles.logP}`}>
            <p>Log:</p>
            {props.userLogs.map(log => {
              if (log.type === 'email') {
                return (
                  <p>- {`${log.user} ${moment(log.added_date).format('DD MMM YY')} ${moment(log.added_time, 'hh:mm:ss').format("HH:mm")} `}</p>
                )
              }

            })}
          </div>
        </div>
        <div className={commonStyles.maxWidth200}>
          <Button color="primary" variant="contained" disabled={!props.consignment.id} className={commonStyles.minWidth100} onClick={props.print}>
            Print
          </Button>
          <div className={`${screeningStyles.fs11} ${screeningStyles.logP}`}>
            <p>Log:</p>
            {props.userLogs.map(log => {
              if (log.type === 'print') {
                return (
                  <p>- {`${log.user} ${moment(log.added_date).format('DD MMM YY')} ${moment(log.added_time, 'hh:mm:ss').format("HH:mm")} `}</p>
                )
              }

            })}
          </div>
        </div>
      </div>
    </Fragment>
  )
};

export default withStyles(styles)(securityConsignment);